export function getActionKey(action, index) {
  return `notification-inline-${action.text}-${index}`
}
